var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8871",
    "data-name": "Group 8871",
    transform: "translate(-343 -451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1492",
    "data-name": "Rectangle 1492",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(353 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1493",
    "data-name": "Rectangle 1493",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(363 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1494",
    "data-name": "Rectangle 1494",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(358 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(343 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(348 451)",
    fill: "#0f3557",
    opacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.9011f12399207570bab9a6732edf430a.svg";
export { ForwardRef as ReactComponent };